import { requestWithToken } from '../utilities/request';


const get_common_path = (fieldId) => {
  return `/api/private/fields/${fieldId}/direct_notice_unapproved_work_settings`;
}

const get_show = fieldId => {
  return requestWithToken({
    method: 'GET',
    url: `${get_common_path(fieldId)}`
  });
};
const get_show_options = fieldId => {
  return {
    method: 'GET',
    url: `${get_common_path(fieldId)}`
  }
}

const get_show_default_response = () => {
  return {
    "result": true,
    "status": 0,
    "message": "",
    "data": {
      "total": 1,
      "entities": {
        "direct_notice_unapproved_work_setting": {
          "talk_id": null,
          "send_schedule_works_time": null,
          "send_result_works_time": null,
          "use_partner_company_approval_flag": 0
        }
      }
    }
  }
}

const show = {
  get: get_show,
  get_options: get_show_options,
  get_default_response: get_show_default_response,
}

const create = (fieldId, params) => {
  return requestWithToken({
    method: 'POST',
    url: `${get_common_path(fieldId)}`,
    data: params
  });
};

const destroy = fieldId => {
  return requestWithToken({
    method: 'DELETE',
    url: `${get_common_path(fieldId)}`
  });
};

export const DirectNoticeUnapprovedWorkSettingsApi = {
  show,
  create,
  destroy
};
export default DirectNoticeUnapprovedWorkSettingsApi;



// WEBPACK FOOTER //
// ./src/services/DirectNoticeUnapprovedWorkSettingsApi.js